export default __webpack_public_path__ + "static/media/solution-2-1-mobile.69707555.jpg";